<template>
  <div class="">
    <div class="row mb-4">
      <div class="col">
        <h2>Your referrals at a glance</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-md-7">
        <div class="row">
          <div class="col-md-6">
            <panel title="Sent this week" class="kpi">
              <span class="kpi-number">{{sentThisWeek}}</span>
            </panel>
          </div>
          <div class="col-md-6">
            <panel title="Schedule rate" class="kpi">
              <span class="kpi-number">{{scheduleRate}}%</span>
            </panel>
          </div>
        </div>
        <panel title="Search referrals">
          <template v-slot:header>
            <router-link to="/referrals">See all
              <font-awesome-icon :icon="['far', 'angle-right']" class="ml-1" />
            </router-link>
          </template>
        </panel>
        <panel title="Your practice"></panel>
      </div>
      <div class="col-md-5">
        <panel title="Your favorites"></panel>
        <panel title="Nearby specialists"></panel>
      </div>
    </div>
  </div>
</template>

<script>
import Panel from '@/components/overview/Panel.vue'
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
export default {
  components: { Panel },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('referrals', ['referrals']),
    sentReferrals() {
      const now = moment()
      const weekStart = moment().startOf('week')

      return this.referrals.filter(
        (s) =>
          !s.is_incoming && !!s.sent_time && weekStart.isBefore(s.sent_time)
      )
    },
    sentThisWeek() {
      return this.sentReferrals.length
    },
    scheduleRate() {
      const all_sentReferrals = this.referrals.filter(
        (s) => !s.is_incoming && !!s.sent_time
      )
      return (
        ((all_sentReferrals &&
          all_sentReferrals.filter((s) => s.scheduled_time).length /
            all_sentReferrals.length) ||
          0) * 100
      ).toFixed(0)
    },
  },
}
</script>

<style>
.kpi-number {
  font-size: 3rem;
  font-weight: bolder;
}
</style>